
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.334 7.122c0-.022-.003-.04-.005-.049a.683.683 0 00-.028-.27 1.9 1.9 0 00-1.869-1.58h-2.449c-.1-.91-.444-1.59-1.085-2.045-.666-.472-1.628-.678-2.896-.678-1.269 0-2.23.206-2.897.678-.64.454-.985 1.136-1.085 2.044H3.57a1.9 1.9 0 00-1.867 1.58c-.027.085-.043.091-.033.185l.004.088c-.002.008-.004.027-.004.048v8.487c0 1.048.853 1.9 1.9 1.9h12.863a1.903 1.903 0 001.9-1.9V7.122zm-8.332-2.933c1.049 0 1.612.144 1.919.356.242.167.34.39.38.677H7.702c.04-.288.138-.51.38-.677.307-.212.87-.356 1.92-.356zM3.57 6.57h12.862a.55.55 0 01.504.335l-1.349 2.348c-.105.183-.305.366-.544.504-.24.139-.498.22-.708.22h-2.413v-.103c0-.71-.577-1.287-1.287-1.287H9.367c-.71 0-1.287.577-1.287 1.287v.104H5.668c-.21 0-.47-.082-.708-.22-.24-.14-.44-.323-.545-.505L3.066 6.906a.55.55 0 01.505-.335zm5.858 3.365h1.146v1.77H9.429v-1.77zm7.003 6.226H3.571a.553.553 0 01-.553-.552V9.529l.228.397c.23.4.61.748 1.04.997.43.248.92.404 1.382.404H8.08v.44c0 .71.578 1.287 1.287 1.287h1.27c.709 0 1.286-.578 1.286-1.287v-.44h2.413c.46 0 .952-.155 1.382-.404.429-.248.81-.597 1.04-.997l.228-.397v6.08a.554.554 0 01-.554.553z","fill":"#9AA0B5"}})])
          )
        }
      }
    